export const salesPolicyTitle = "ÖN BİLGİLENDİRME FORMU, SATIŞ POLİTİKASI, TESLİMAT KOŞULLARI, İPTAL VE İADE PROSEDÜRÜ";
export const salesPolicyDocumentTitle = "Ön Bilgilendirme ve Diğer Politikalar";

export const salesPolicySections = [
    {
        heading: "ÖN BİLGİLENDİRME FORMU ve SATIŞ POLİTİKASI",
        main: true,
        paragraphs: [
            "Bu form, 6563 sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun'un 3. maddesi uyarınca, Ahtabot ve UYAP Görev Yöneticisi (UGY) abonelik paketlerinin elektronik ortamda satın alınmasından önce alıcıları bilgilendirmek amacıyla hazırlanmıştır."
        ]
    },
    {
        heading: "Satıcı ve Hizmet Sağlayıcı",
        sub: true,
        labeled: true,
        paragraphs: [
            "Ünvan: ETCBASE Yazılım ve Bilişim Teknolojileri Anonim Şirketi",
            "Adres: Reşitpaşa Mah. Katar Cad. İTÜ Arı Teknokent 2 No: 4/1 Kat: 5 No: 501, 34467 Sarıyer / İstanbul",
            "Telefon: +90 212 987 50 00",
            "Ahtabot Üyelik: +90 531 731 93 75 / www.etcbase.com/ahtabot",
            "Teknik Destek: +90 212 987 51 00 / helpdesk@etcbase.com",
            "İnternet Sitesi: www.etcbase.com",
            "MERSİS No: 0381042701700014",
            "Ticaret Sicil No: 751955-0 (İstanbul Ticaret Sicili Müdürlüğü)",
            "Vergi Dairesi ve Vergi No: MASLAK VERGİ DAİRESİ / 3810427017",
            "KEP Adresi: etcbase@hs03.kep.tr"
        ]
    },
    {
        heading: "Hizmetin Temel Nitelikleri",
        sub: true,
        paragraphs: [
            "Ahtabot, hukuk bürolarının UYAP üzerindeki icra takip işlemlerini kullanıcının kendi UYAP oturumu ve elektronik imzası üzerinden izleyen, raporlayan ve kullanıcı tercihlerine göre toplu veya tekil işlem yapılmasını sağlayan bir robotik süreç otomasyonu uygulamasıdır. UGY, Ahtabot aboneliği ile birlikte ek ücret alınmaksızın sunulur. Hizmet, avukatlar ve hukuk büroları için mesleki kullanıma yöneliktir."
        ]
    },
    {
        heading: "Paketler, Fiyat ve Ödeme",
        sub: true,
        paragraphs: [
            "Paketler dosya adedi ve süreye göre tanımlanır. Güncel paketler ve fiyatlar ödeme sayfasında KDV hariç olarak gösterilir, ödeme adımında KDV dahil toplam tutar ayrıca gösterilir. Ödeme, ödeme kuruluşunun güvenli ödeme sayfası üzerinden kredi kartı veya banka kartı ile peşin/taksitli yapılabilir. Kart bilgileri ETCBASE tarafından görülmez ve saklanmaz. UYAP harç ve masrafları ile Barokart ödemeleri paket bedeline dahil değildir."
        ]
    },
    {
        heading: "Sözleşmenin Kurulması ve İşlem Rehberi",
        sub: true,
        paragraphs: [
            "Bu form, üyelik ve ödeme öncesinde herkesin erişimine açıktır. Alıcı önce üyelik formunu doldurur, ardından ödeme sayfasında paketi seçer. Ödeme adımında seçilen paket, dosya adedi, süre, varsa indirim, KDV hariç bedel ve KDV dahil toplam bedel sipariş özeti olarak gösterilir. Alıcı bu bilgileri ödemeyi tamamlamadan önce kontrol edip düzeltebilir, üyelik bilgilerindeki hatalar, ahtabot@etcbase.com adresine yazılarak düzeltilir."
        ]
    },
    {
        heading: "Abonelik Süresi",
        sub: true,
        paragraphs: [
            "Abonelik, süre sonunda kendiliğinden yenilenmez ve karttan yeniden tahsilat yapılmaz. Devam etmek isteyen alıcı yeni bir paket satın alır."
        ]
    },
    {
        heading: "Kişisel Veriler",
        sub: true,
        paragraphs: [
            "Kişisel veriler, Platform'da yayımlanan Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni kapsamında işlenir."
        ]
    },
    {
        heading: "Şikayet ve Uyuşmazlık",
        sub: true,
        paragraphs: [
            "Şikayet ve talepler ahtabot@etcbase.com adresine iletilebilir ve en geç 3 iş günü içinde cevaplanır. Uyuşmazlıklarda kanunen yetkili mahkemeler ve icra daireleri yetkilidir. Alıcının tüketici sayılması halinde tüketici hakem heyetleri ve tüketici mahkemelerine ilişkin hükümler saklıdır."
        ]
    },
    {
        heading: "TESLİMAT VE HİZMETİN İFASI",
        main: true,
        paragraphs: [
            "Ahtabot ve UYAP Görev Yöneticisi (UGY) abonelikleri dijital hizmettir. Fiziki bir ürün teslimatı yapılmaz, kargo veya teslimat ücreti alınmaz."
        ]
    },
    {
        heading: "Hesabın Kullanıma Açılması",
        sub: true,
        paragraphs: [
            "Ödemenin ödeme kuruluşu tarafından onaylanmasını takiben aboneliğiniz seçtiğiniz paket için en geç 1 iş günü içinde kullanıma açılır ve durum üyelik formunda beyan ettiğiniz e-posta adresine bildirilir. Hesabın kullanıma açılmasıyla abonelik başlar ve paket süresi bu tarihten itibaren işler. ETCBASE'in seçilen paket kapsamındaki hizmeti abonelik süresince sunma yükümlülüğü devam eder."
        ]
    },
    {
        heading: "Erişim",
        sub: true,
        paragraphs: [
            "Hizmete ahtabot.yts.com.tr adresi üzerinden YTS Avukat UYAP Browser ile erişilir. Hizmetten yararlanabilmek için geçerli bir UYAP Avukat Portal erişiminiz ve elektronik imzanız bulunmalıdır. UYAP Avukat Portal tarafındaki erişim sorunları, bakım ve güncellemeler ETCBASE'in sorumluluğunda değildir."
        ]
    },
    {
        heading: "Paket Kapsamı",
        sub: true,
        paragraphs: [
            "Paketler, ödeme sayfasında belirtilen dosya adedi ve süre ile sınırlıdır. UGY, Ahtabot aboneliği ile birlikte ek ücret alınmaksızın kullanıma açılır. UYAP üzerinden yapılan sorgu, tebligat, haciz ve benzeri işlemlere ilişkin harç, masraf ve Barokart ödemeleri abonelik bedeline dahil değildir ve aboneye aittir."
        ]
    },
    {
        heading: "Fatura",
        sub: true,
        paragraphs: [
            "Fatura, üyelik formunda beyan edilen unvan, vergi dairesi, vergi numarası ve adrese göre elektronik ortamda düzenlenir ve e-posta adresinize gönderilir."
        ]
    },
    {
        heading: "Destek",
        sub: true,
        paragraphs: [
            "Aktivasyon ve erişim konularında ahtabot@etcbase.com adresine veya +90 531 731 93 75 numarasına, teknik konularda helpdesk@etcbase.com adresine veya +90 212 987 51 00 numarasına ulaşabilirsiniz."
        ]
    },
    {
        heading: "İPTAL VE İADE POLİTİKASI",
        main: true,
        paragraphs: [
            "Bu politika, ETCBASE Yazılım ve Bilişim Teknolojileri Anonim Şirketi (\"ETCBASE\") tarafından Ahtabot ve UYAP Görev Yöneticisi (UGY) için sunulan abonelik paketlerine uygulanır ve Mesafeli Satış ve Abonelik Sözleşmesi'nin 9. maddesinin özetidir."
        ]
    },
    {
        heading: "Cayma Hakkı",
        sub: true,
        paragraphs: [
            "Ahtabot ve UGY avukatlar ve hukuk bürolarına mesleki kullanım için sunulduğundan aboneler tüketici sıfatını taşımaz ve cayma hakkı bulunmaz. Abonenin istisnaen tüketici sayılması halinde, hizmetin ifasına abonenin talebi ile ödemenin onaylanmasını takiben derhal başlandığından Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesinin birinci fıkrasının (h) bendi uyarınca cayma hakkı kullanılamaz."
        ]
    },
    {
        heading: "Kullanım Başlamadan İade",
        sub: true,
        paragraphs: [
            "Ödeme tarihinden itibaren 7 gün içinde, Platform'a henüz dosya aktarılmamış ve hizmet fiilen kullanılmaya başlanmamış ise, ahtabot@etcbase.com adresine gönderilecek yazılı talep üzerine ödenen bedelin tamamı iade edilir."
        ]
    },
    {
        heading: "Hizmetin Sunulamaması Halinde İade",
        sub: true,
        paragraphs: [
            "Hizmetin ETCBASE'den kaynaklanan bir nedenle paket süresi içinde kesintisiz olarak 5 iş gününden uzun süre sunulamaması halinde abone sözleşmeyi feshedebilir ve kullanılmayan döneme karşılık gelen bedel iade edilir. Hizmetin hiç başlamaması, temel işlevlerden birinin ETCBASE'den kaynaklanan bir nedenle çalışmaması veya arızaların tekrarlanması halinde abone aykırılığı yazılı olarak bildirir ve giderilmesi için en az 10 iş günü süre verir, aykırılık giderilmezse aynı şekilde fesih ve iade hakkı doğar. UYAP Avukat Portal kaynaklı erişim sorunları bu kapsamda değildir."
        ]
    },
    {
        heading: "İade Yapılmayan Haller",
        sub: true,
        paragraphs: [
            "Paket süresi dolmadan hizmeti kullanmaktan vazgeçilmesi veya paketin kısmen kullanılması iade hakkı doğurmaz. Üyelik ve Gizlilik Sözleşmesi'nin ihlali halinde ETCBASE önce yazılı uyarıda bulunur ve 5 iş günü giderim süresi verir, güvenlik riski doğuran ihlallerde hesap derhal askıya alınabilir. Süresinde giderilmeyen ihlal nedeniyle hesabın kapatılması halinde iade yapılmaz. Abonelik süre sonunda kendiliğinden yenilenmez, bu nedenle yenileme iptali gerekmez."
        ]
    },
    {
        heading: "İade Yöntemi ve Süresi",
        sub: true,
        paragraphs: [
            "İade talepleri en geç 3 iş günü içinde cevaplanır. Kabul edilen iadeler, kabul bildirimini takip eden 10 iş günü içinde ödemenin yapıldığı karta ödeme kuruluşu aracılığıyla başlatılır. Tutarın karta yansıma süresi kartı veren bankaya göre değişir. İade halinde düzenlenen fatura iptal edilir veya iade faturası düzenlenir."
        ]
    },
    {
        heading: "İade Talebi",
        sub: true,
        paragraphs: [
            "İade talepleri, üyelik formunda beyan edilen e-posta adresinden ahtabot@etcbase.com adresine, hukuk bürosu adı ve ödeme tarihi belirtilerek iletilir."
        ]
    },
    {
        heading: "İletişim",
        sub: true,
        labeled: true,
        paragraphs: [
            "Unvan: ETCBASE Yazılım ve Bilişim Teknolojileri Anonim Şirketi",
            "Adres: Reşitpaşa Mah. Katar Cad. İTÜ Arı Teknokent 2 No: 4/1 Kat: 5 No: 501, 34467 Sarıyer / İstanbul",
            "Telefon: +90 212 987 50 00",
            "E-posta: ahtabot@etcbase.com"
        ]
    }
];
